export default "/assets/images/whitenoise-mode.b51c681969de126a.webm";